import { render } from "./SelectPatient.vue?vue&type=template&id=68645cca&scoped=true&lang=pug"
import script from "./SelectPatient.vue?vue&type=script&lang=js"
export * from "./SelectPatient.vue?vue&type=script&lang=js"

import "./SelectPatient.vue?vue&type=style&index=0&id=68645cca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68645cca"]])

export default __exports__